import { Injectable } from '@angular/core';
import { ApiService } from '../../../core/services/api.service';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../../core/shared/classes/api';
import { EtatTache } from '../classes/etatTache';

@Injectable()
export class EtatTacheService {

    constructor (private apiService: ApiService) {}

    getEtatTache(): Observable<ApiResponse> {
        return this.apiService.get('etat-tache/' );
    }

    getEtatTacheById(id: any): Observable<ApiResponse> {
        return this.apiService.post('etat-tache/' + id);
    }

    insertEtatTache(data: any): Observable<ApiResponse> {
        return this.apiService.post('etat-tache', data);
    }

    updateEtatTache(id: string, data: any): Observable<ApiResponse> {
        return this.apiService.put('etat-tache/' + id, data);
    }

    deleteEtatTache(id: string): Observable<ApiResponse> {
        return this.apiService.delete('etat-tache/' + id);
    }
}
